declare global {
  interface Window {
    dev: () => boolean;
    hasRemote: () => boolean;
    hasMode: (mode) => boolean;
    mode: string;
    savedStore: any;
    locationHistory: string;
    // USE_UPDATED_NAV: boolean;
    IS_CHAMELEON_MODULE: boolean;
    chameleon: any;
    fonts: any;
    FontFace: any;
  }
  interface Document {
    fonts: any;
  }
}

if (!('IntersectionObserver' in window)) require('intersection-observer');

import 'whatwg-fetch';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import React, { Fragment as _ } from 'react';
import ReactDOM from 'react-dom';
import './setup';
import getStore from 'services/getStore';
import { Provider } from 'react-redux';
import Module from 'components/Module';
import 'services/scorm/scormService';
import { addFont } from 'services/fontService';
import 'styles/global';
import { ErrorBoundary } from 'components/errorHandler';

import 'regenerator-runtime/runtime.js';

import 'assets/whoopsBrowserIncompatible.png';
import 'assets/Carousel_Placeholder.png';
import 'assets/clickNReveal_default.png';
import 'assets/Correct_loop.gif';
import 'assets/Incorrect_loop.gif';
import 'assets/Attempt.svg';
import 'assets/Incorrect_default.svg';
import 'assets/FlipCard_loop.gif';
import 'assets/Media_default.svg';
import 'assets/Media_loop.gif';
import 'assets/animations/placeholder.js';
import 'assets/MultiChoice_loop.gif';
import 'assets/Loader_Logo_2.gif';
import 'assets/lizard.svg';

import getModuleImages from 'services/getModuleImages';
import ModuleImagesPreloader from 'components/lib/PreLoaders/ModuleImagesPreloader';

window.hasRemote = () => getParams().hasRemote;

window.dev = () => !!parent.IS_CHAMELEON_EDITOR;

// disable all react-beautiful-dnd development warnings
window['__react-beautiful-dnd-disable-dev-warnings'] = true;

const store = getStore();

try {
  window.hasMode = mode => {
    const windowMode = window.mode || 'DEVELOPMENT';
    return mode === windowMode;
  };

  window.client = parent.client;
} catch (err) {
  // console.warn(err);
}

const loadTheme = store.subscribe(() => {
  const {
    backgroundColor = '',
    fontFamily = '',
    fontFamilies = [],
  } = store.getState().theme;

  document.body.style.background = backgroundColor;

  if (!!fontFamilies.length) {
    fontFamilies.forEach(f => {
      addFont(f);
    });
  }

  // just wanting to smash this until it displays for sure
  if (fontFamily) {
    const checkFontFamilyDisplays = setInterval(() => {
      if (document.body.style.fontFamily === `"${fontFamily}"`)
        clearInterval(checkFontFamilyDisplays);
      document.body.style.fontFamily = fontFamily;
    }, 0);
  }

  loadTheme.unsubscribe && loadTheme.unsubscribe();
});

const readCookie = (name: string) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const isHosted = (window as any).getParams().hosted;
const ccURL = (window as any).chameleon.CHAMELEON_URL;

if (isHosted) {
  const projectId = (window as any).getParams().projectId;
  const csrfToken = decodeURIComponent(readCookie('X-CSRF-TOKEN') as string);

  fetch(`${ccURL}/harp/hosting/${projectId}/session`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json',
    },
  });
}

ReactDOM.render(
  <_>
    <ErrorBoundary>
      {/* <GraphQlProvider value={client}> */}
      {/* <ImagePreloader /> */}
      <Provider store={store}>
        <Module />
      </Provider>
      {/* </GraphQlProvider> */}
    </ErrorBoundary>
    {/* {!window.dev() && <BootScreen theme={store.getState().theme} />} */}

    {window.dev &&
      !window.dev() &&
      store.getState().theme.useImagePreloader && (
        <ModuleImagesPreloader images={getModuleImages()} />
      )}
  </_>,
  document.querySelector('#root')
);

// if (module && module['hot']) module['hot'].accept();
